import * as React from 'react';
import Button from 'src/components/ui-kit/Button/Button';
import GeneralModal from 'src/components/views/GeneralModal/GeneralModal';
import { ProductSubscriptions, ProductSubscriptionType } from '../../../hooks/ProductSubscriptions/ProductSubscriptions.types';
import FormInput from '../../views/FormInput/FormInput';
import ModalContent from '../../views/ModalParts/ModalContent/ModalContent';
import ModalHeading from '../../views/ModalParts/ModalHeading/ModalHeading';
import ModalLayout from '../../views/ModalParts/ModalLayout/ModalLayout';
import { styles } from './AddUserEmailToSubscriptionModal.styles';
import useLocalization from 'src/services/localization/useLocalization';

interface Props {
  email: string;
  errorText: string;
  wishedSubscriptionType: ProductSubscriptionType | null;
  onSubscribe(): void;
  onClose(): void;
  onChangeEmail(email: string): void;
}

const AddUserEmailToSubscriptionModal = (props: Props) => {
  const {
    email,
    errorText,
    wishedSubscriptionType,
    onSubscribe,
    onClose,
    onChangeEmail,
  } = props;
  const localize = useLocalization();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubscribe();
  };

  const titleTranslationId = getTitleTranslationId(wishedSubscriptionType);

  const titleText = titleTranslationId ? localize(titleTranslationId) : null;


  return(
    <GeneralModal
      isCentered
      isModalOpen
      onCloseModal={onClose}
      dataMarker="Add User Email To Subscription Modal"
      dataTestId="AddUserEmailToSubscriptionModal"
    >
      <ModalLayout>
        {
          !!titleText && (
            <ModalHeading>{titleText}</ModalHeading>
          )
        }

        <form onSubmit={handleSubmit}>
          <ModalContent alignedLeft>
            <p className='AddUserEmailToSubscriptionModal__text'>
              {localize('add_email_to_subscribe_modal_text')}
            </p>

            <FormInput
              inputProps={{
                autoFocus: true,
                dataMarkerValue: 'Email',
              }}
              labelText={localize('general.email')}
              value={email}
              onChange={onChangeEmail}
              inputName={'user_email'}
              errorMessage={errorText}
            />
          </ModalContent>

          <div className="AddUserEmailToSubscriptionModal__wrapSubmitButton">
            <Button
              fullWidth
              dataMarkerValue="Subscribe"
              onClick={onSubscribe}
            >
              {localize('general_subscribe_to')}
            </Button>
          </div>

        </form>
      </ModalLayout>
      <style jsx>{styles}</style>
    </GeneralModal>
  );
};

const titleTranslationIdsMap: {
  [Property in keyof ProductSubscriptions]: string;
} = {
  discount: 'general_inform_about_discount',
  availability: 'general_inform_about_availability',
};

function getTitleTranslationId(wishedSubscriptionType: ProductSubscriptionType | null): string | null {
  if(!wishedSubscriptionType) {
    return null;
  }

  return titleTranslationIdsMap[wishedSubscriptionType];
}

export default AddUserEmailToSubscriptionModal;
